<template>
    <footer class="text-center">
        <div>
            Brasil (UTC-3) - Horário de Brasília, a hora oficial do Brasil • 
            {{ dateTime }}
        </div>
        <p>
            Powered by Conexa Saúde
            <template v-if="softwareVersion">| Versão:  {{ softwareVersion }}</template>
            | CNPJ 27.092.748/0001-18
        </p>
    </footer>
</template>

<script>
export default {
    name: 'footer',
    props: {
        softwareVersion: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            currentDate: new Date(),
            dateTime: '',
        }
    },
    mounted() {
        setInterval(() => this.updateTime(), 1000)
    },
    computed: {
        stringifyDate() {
            const dt = new Intl.DateTimeFormat('pt-BR', {
                timeZone: 'America/Sao_Paulo',
                dateStyle: 'full',
            }).format(this.currentDate)

            return dt
        },
        stringifyTime() {
            const dt = new Intl.DateTimeFormat('pt-BR', {
                timeZone: 'America/Sao_Paulo',
                timeStyle: 'medium',
            }).format(this.currentDate)

            return dt
        },
    },
    methods: {
        updateTime() {
            this.currentDate = new Date()
            this.dateTime = this.stringifyDate + ' - ' + this.stringifyTime
        },
    }
}
</script>

<style scoped>
    footer div {
        color: #b6b6b6;
        margin-top: 16px;
        margin-bottom: 16px;
    }
</style>